import {IApplicationState} from '../../../../../../types/types';
import { filterPanelBoardsSelector } from './filterPanelBoardsSelector';

export const getFilterPanelIsInitial = (
    state: IApplicationState,
    boardId: number
): boolean => {
    return filterPanelBoardsSelector(state, boardId).isInitial;
};
